<template>
  <div>
    <div id="header-info">
      <div class="topbar">
        <topbar />
      </div>
      <div>
        <search @search="search" />
      </div>
    </div>
    <div>
      <cart-side />
    </div>
    <div>
      <app-nav />
    </div>
    <div class="item-details">
      <div class="item-info">
        <b-container>
          <b-row>
            <b-col cols="4">
              <div class="item-pic"><img :src="item.image" alt=""></div>
            </b-col>
            <b-col>
              <p class="item-details-name">
                <span>{{ item.commonName }}</span>
                <span>{{ item.name }}</span>
                <span v-show="item.promotionType!==-1" class="active-type" style="color: #f00;">{{ item.promotionDesc }}</span>
              </p>
              <p class="item-details-norm"><span class="text-justify">规格</span>：{{ item.norm }}</p>
              <p class="item-details-manufature"><span class="text-justify">生产厂家</span>：{{ item.manufacturer }}</p>
              <p class="item-license-number"><span class="text-justify">批准文号</span>：{{ item.licenseNumber }}</p>
              <p class="item-large-scale"><span class="text-justify">大包装</span>：{{ item.largeScale }}</p>
              <p class="item-sell-unit"><span class="text-justify">销售单位</span>：{{ item.basicUnit }}</p>
              <p class="item-details-inventory"><span class="text-justify">库存</span>：{{ item.inventory }}</p>
              <p class="item-expiry-time"><span class="text-justify">有效期至</span>：{{ item.expiryTime }}</p>
              <p class="item-details-price">
                <span class="sell-price"><span class="text-justify">销售价</span>：￥{{ item.showPrice }}</span>
                <span class="instruct-price" style="margin-left: 40px;">参考价：￥{{ item.instructPrice }}</span>
              </p>
              <p class="item-shop-name"><span class="text-justify">供应商</span>：{{ item.shopName }}</p>
              <p v-if="item.promotionType!==-1">
                <item-active :promotion="item.promotion" />
              </p>
              <div class="add-to-cart">
                <div class="select-cart-num">
                  <span class="discount-num" @click="cutdown">-</span>
                  <input v-model="cartNum" type="text" :disabled="item.disabled" @blur="changeNum">
                  <span class="add-num" @click="add">+</span>
                </div>
                <div class="addcart-img">
                  <a href="javascript:void(0)" @click="addToCart"><img src="../../../static/images/item_details_cart.png" alt=""></a>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-container>
      </div>
      <div class="item-desc">
        <b-container>
          <b-row>
            <b-col class="item-visited" cols="2">
              <p class="title">你浏览过的</p>
              <div class="visited-details">
                <div v-for="(itemView,index) in itemVisited" :key="index" @click="goto(itemView.id)">
                  <b-card
                    :img-src="itemView.image"
                    img-alt="Image"
                    img-top
                  >
                    <b-card-text>
                      {{ itemView.name }}
                    </b-card-text>
                    <b-card-text>
                      ￥{{ itemView.showPrice }}
                    </b-card-text>
                  </b-card>
                </div>
              </div>
            </b-col>
            <b-col class="item-about">
              <b-tabs card>
                <b-tab title="商品说明" active>
                  <div v-if="item.desc" class="item-description" v-html="dealText()" />
                </b-tab>
                <b-tab title="订购说明">
                  <div class="order-desc">
                    <span>采购流程:</span>
                    <div class="order-step">
                      <div v-for="(step,index) in orderStep" :key="index">
                        <div class="step-details">
                          <b-card :img-src="step.img" img-alt="" img-left>
                            <b-card-text>
                              <p class="text-title">1.{{ step.title }}</p>
                              <p class="text-red">{{ step.desc }}</p>
                            </b-card-text>
                          </b-card>
                          <span v-if="step.nextStep" class="next-step">
                            <img src="../../../static/images/next_step.png" alt="">
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-tab>
              </b-tabs>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </div>
    <div>
      <app-footer />
    </div>
  </div>
</template>
<script>
import footer from '@/components/Footer.vue'
import topbar from '@/components/TopBar.vue'
import search from '@/components/Search.vue'
import nav from '@/components/Nav.vue'
import img1 from '../../../static/images/shopping_1.png'
import img2 from '../../../static/images/shopping_2.png'
import img3 from '../../../static/images/shopping_3.png'
import img4 from '../../../static/images/shopping_4.png'
import img5 from '../../../static/images/shopping_5.png'
import { ItemService } from '@/service/ItemService'
import CartSide from './CartSide'
import ItemActive from './ItemActive.vue'
export default {
  components: {
    'cart-side': CartSide, 'app-nav': nav,
    search, topbar, 'app-footer': footer,
    'item-active': ItemActive
  },
  data () {
    return {
      item: {},
      cartNum: 1,
      itemVisited: [],
      orderStep: [
        { img: img1, title: '选择商品', desc: '将您挑选好的商品加入购物车', nextStep: true },
        { img: img2, title: '确认订单', desc: '确认购买商品、地址、货到付款', nextStep: true },
        { img: img3, title: '订单提交成功', desc: '确认提交订单', nextStep: false },
        { img: img4, title: '确认收货', desc: '收到商品后，支付商品费用', nextStep: true },
        { img: img5, title: '完成交易', desc: '交易完成', nextStep: false }
      ]
    }
  },
  beforeRouteEnter (to, from, next) {
    var id = to.query.id
    next(vm => {
      vm.fetchData(id)
    })
  },
  mounted () {
    document.scrollTop = 0
    document.documentElement.scrollTop = 0
    this.loadItemVisited()
  },
  methods: {
    search () {

    },
    add () {
      if (!this.item.disabled) {
        this.cartNum++
      }
    },
    goto (itemId) {
      this.$router.push({ path: '/item', query: { id: itemId }})
      this.fetchData(itemId)
    },
    cutdown () {
      if (this.cartNum !== 1) {
        this.cartNum--
      }
    },
    changeNum () {
      this.cartNum = Number(this.cartNum)
    },
    showToast (str) {
      this.$bvToast.toast(str, {
        title: '加入购物车',
        autoHideDelay: 2000
      })
    },
    dealItemNum (count, inventory) {
      // 购物车数量为0或超出库存时
      let result = 1
      if (inventory === 0 || count > inventory) {
        result = inventory === 0 ? -1 : 2
      }
      return result
    },
    dealAddNum (item) {
      const itemCart = this.$store.getters.getItemById(item.id)
      if (itemCart.length !== 0 && itemCart[0].num > 0) {
        if (itemCart[0].num >= item.inventory) {
          this.showToast('库存不足')
          return -1
        } else {
          var num = itemCart[0].num + this.cartNum
          num = num < item.inventory ? num : item.inventory
          return num
        }
      } else {
        return this.cartNum < item.inventory ? this.cartNum : item.inventory
      }
    },
    addToCart () {
      const item = this.item
      let price = Number(item.showPrice) === 0 ? item.instructPrice : item.showPrice
      price = item.promotion.activePrice || price
      console.log(item, 'item num')
      if (isNaN(price) || Number(price) === 0) {
        this.showToast('价格错误')
        return
      } else {
        const result = this.dealItemNum(this.cartNum, item.inventory)
        console.log(result, this.cartNum, 'result')
        if (result === 2 || result === 1) {
          if (this.dealAddNum(item) !== -1) {
            item.num = this.dealAddNum(item)
            const tmpItem = { price: price };
            ({ id: tmpItem.id, num: tmpItem.num, image: tmpItem.image, shopId: tmpItem.shopId, shopName: tmpItem.shopName,
              norm: tmpItem.norm, commonName: tmpItem.name, manufacturer: tmpItem.manufacture } = item)
            console.log(tmpItem, 'tmpItem')
            this.$store.commit('addTocart', tmpItem)
            this.showToast(`加入购物车成功`)
            this.cartNum = 1
            return
          } else {
            this.cartNum = 1
            return
          }
        } else {
          this.cartNum = 1
          return
        }
      }
    },
    dealText () {
      var content = this.item.desc
      if (this.item.desc !== undefined || this.item.desc !== '') {
        var str1 = this.item.desc.replace(/【/g, '<p>')
        content = str1.replace(/】/g, ':')
      }
      return content
    },
    fetchData (id) {
      const Item = new ItemService(this.$axios)
      Item.loadFullInfo([id]).then((item) => {
        this.setValue(item)
      })
    },
    loadItemVisited () {
      var itemIds = this.$store.getters.getVisitedItems
      console.log(itemIds, 'itemIds')
      var query = this.$route.query.id
      itemIds = itemIds.filter(itemId => itemId !== query)
      console.log(query, itemIds, 'kksks')
      const Item = new ItemService(this.$axios)
      Item.loadFullInfo(itemIds).then((items) => {
        items.forEach(item => {
          var tmpItem = {};
          ({ image: tmpItem.image, name: tmpItem.name, showPrice: tmpItem.showPrice, id: tmpItem.id } = item)
          this.itemVisited.push(tmpItem)
        })
      })
      console.log(this.itemVisited, 'itemVisited')
    },
    setValue (items) {
      var newItem = items[0] || []
      console.log(newItem, 'llslflal')
      if (newItem.promotionType !== -1) {
        var promotion = newItem.promotion
        var str = promotion.disType === 1 ? '元' : newItem.basicUnit
        if (newItem.promotionType === 1) {
          var rules = []
          newItem.promotion.gradsRules.forEach(ruleInfo => {
            console.log(ruleInfo, 'rule')
            var ruleGift = `购买 ${newItem.commonName} 满${ruleInfo.amount}${str} 送${ruleInfo.giftName} X${ruleInfo.giftNumber}`
            rules.push(ruleGift)
          })
          newItem.promotion.gradsRules = rules
        } else if (newItem.promotionType === 2) {
          var ruleNew = `活动起订量：${promotion.least}${newItem.basicUnit} 活动限购${promotion.limitNum}${newItem.basicUnit}，超出数量按原价购买`
          newItem.promotion.businessPromotionItems = ruleNew
        }
      }
      this.item = newItem
      console.log(this.item, 'this.itemsls')
    }
  }
}
</script>
<style>
  p {
    margin-bottom: 0;
  }
  .item-details {
    max-width: 1200px;
    margin: 0 auto;
    font-size: 1.125rem;
    background-color: #fff;
  }
  .item-info p {
    margin-left: 0;
    margin-bottom: 0;
    font-weight: normal;
    height: auto;
    line-height: 30px;
    }
  .item-info {
    padding-top: 30px;
    padding-bottom: 30px;
  }
  .item-info .col-4{
    flex: 0 0 31%;
    padding-left: 25px;
    padding-right: 0;
    max-width: 31%;
    height: auto;
  }
  .item-info .item-pic {
    width:300px;
    height: 300px;
  }
  .item-info .text-justify {
    display:inline-block;
    width: 5rem;
    text-align-last:justify;
    text-align:justify;
    text-justify:distribute-all-lines;
  }
  .item-pic img {
    position: relative;
    top: 0;
    width: 100%;
    height: 100%;
  }
  .item-info .col {
    padding-right: 0;
    padding-left: 0;
    text-align: left;
    height: auto;
  }
  .item-details .col-2 {
    padding-left: 0;
    padding-right: 0;
    flex: 0 0 16%;
  }
  .item-info .item-details-name,
  .item-info .sell-price,
  .item-info .item-shop-name{
    font-size: 1.25rem;
    font-weight: bold;
  }
  .item-info .item-details-name span:nth-child(2) {
    margin-left: 20px;
    margin-right: 80px;
  }
  .item-info .activity-desc {
    width: 700px;
    height: 80px;
    background-color: #e3e4e5;
    display: flex;
    margin: 30px 0 10px 0;
  }
  .activity-desc .active-type {
    line-height: 80px;
    padding: 0 5px;
  }
  .activity-desc .active-desc {
    font-size: 0.75rem;
    font-weight: normal;
  }
  .item-info .add-to-cart {
    height: 45px;
    display: flex;
    text-align: center;
  }
  .add-to-cart .select-cart-num {
    margin-right: 20px;
  }
  .select-cart-num input:disabled {
    background-color: #f5f5f5;
  }
  .add-to-cart span {
    width: 45px;
    height: 45px;
    cursor: pointer;
    display: inline-block;
    border: 1px solid #ccc;
    background-color: #f5f5f5;
    text-align: center;
    vertical-align: middle;
  }
  .add-to-cart input {
    height: 45px;
    width: 100px;
    border-left: 0;
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    padding: 0;
    text-align: center;
    border-right: 0;
    vertical-align: middle;
  }
  .item-desc .item-visited .title{
    height: 36px;
    background-color: #e3e4e5;
    line-height: 36px;
    text-align: left;
    padding-left: 24px;
    margin-bottom: 0;
  }
  .item-desc .col {
    padding-left: 20px;
    padding-right: 0;
    height: auto;
    background-color: #fff;
  }
  .item-desc .card-header {
    border-radius: 0;
    background-color: #e3e4e5;
    padding: 2px 0 2px 45px;
    border: 0;
    height: 36px;
  }
  .item-desc .nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link {
    color: #000;
    background-color: #fff;
    border:0;
  }
  .item-desc .nav-tabs .nav-link {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }
  .item-desc .nav-link {
    padding: 0;
    height:32px;
    width: 102px;
    line-height: 32px;
  }
  .item-desc a {
    color: #000;
    font-weight: normal;
  }
  .item-desc .nav-tabs .nav-item:first-child {
    margin-right: 36px;
  }
  .item-desc .visited-details {
    border: 1px solid #ccc;
    max-height: 1200px;
    overflow-y: scroll;
  }
  .visited-details div {
    cursor: pointer;
  }
  .visited-details .card p:first-child {
    margin-bottom: 0;
    max-height: 50px;
    overflow: hidden;
  }
  .visited-details .card p:last-child {
    line-height: 34px;
    font-weight: bold;
  }
  .visited-details .card {
    border-radius: 0;
    margin:24px;
    border: 0;
    border-bottom: 1px dashed #ccc;
  }
  .visited-details > div:last-child .card {
    border-bottom: 0;
  }
  .visited-details .card-img-top {
    border-top-right-radius: 0;
    border-top-left-radius: 0;
  }
  .visited-details .card-body {
    padding: 0;
    margin-top: 14px;
  }
  .item-about .card-body {
    text-align: left;
    padding: 0;
    font-size: 0.75rem;
  }
  .item-about .order-desc,
  .item-about .item-description {
    min-height: 310px;
    border: 1px solid #ccc;
    padding: 40px 20px 20px 20px;
    font-weight: normal;
  }
  .order-step .card {
    border: 1px solid #e0e0e0;
    background-color: #f3f3f2;
    display: inline-block;
    width:262px;
    height: 80px;
    border-radius: 40px;
    padding: 24px 0 24px 24px;
  }
  .order-step div {
    display: inline-block;
  }
  .order-step .step-details {
    margin-bottom: 24px;
  }
  .order-step .next-step {
    display: inline-block;
    height: 80px;
    width: 56px;
    text-align: center;
    vertical-align: middle;
  }
  .order-step .text-title {
    font-size: 1rem;
    font-weight: bold;
    margin-bottom: 5px;
  }
  .order-step .text-red {
    color: #f00;
  }
  .order-step p {
    height: 16px;
    line-height: 10px;
  }
  .order-step .card-img-left {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    width: 32px;
    height: 32px;
    margin-right: 12px;
    vertical-align: top;
  }
</style>
